import { render, staticRenderFns } from "./product-pictures-template.vue?vue&type=template&id=c74e1c58&scoped=true"
import script from "./product-pictures-template.vue?vue&type=script&lang=ts"
export * from "./product-pictures-template.vue?vue&type=script&lang=ts"
import style0 from "./product-pictures-template.vue?vue&type=style&index=0&id=c74e1c58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74e1c58",
  null
  
)

export default component.exports